import { createSelector } from 'reselect';
import { filter, get } from 'lodash/fp';

const activeMembershipsSelector = createSelector(
  get(['auth', 'memberships']),
  filter({ status: 'active' }),
);

export default activeMembershipsSelector;
